import React from "react";

import Hero from "../components/Hero";
import About from "../components/About";
import GallerySection from "../components/GallerySection";
import Skills from "../components/Skills";
import Interview from "../components/Interview";
import Testimonial from "../components/Testimonial";
import Contact from "../components/Contact";

const Home = () => {
  return (
    <>
      <Hero />
      <About />
      <GallerySection />
      <Skills />
      <Interview />
      <Testimonial />
      <Contact />
    </>
  );
};

export default Home;